import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Link } from "react-router-dom";

type Faq = {
  question: string;
  answer: string;
};

const FAQS: Faq[] = [
  {
    question: "What do you do?",
    answer:
      "We build AI systems that cut costs and lift revenue inside your operations. Our 3-step process: map where AI can have the biggest impact in your business, build the systems that capture it, and hand them off to your team to own and run.",
  },
  {
    question: "Why AI?",
    answer:
      "Boards are asking for it, investors are demanding it, and competitors are already implementing it. We don't subscribe to all the hype, but the impacts are real.",
  },
  {
    question: "How do I know this will work for me?",
    answer:
      "You don't have to know going in. That's why the first step is developing a map specific to your business. If the savings aren't there, you don't pay. If they are, you have a build plan ready to go.",
  },
  {
    question: "How does the guarantee work?",
    answer:
      "We complete the Margin Expansion Map and deliver the report. If we haven't surfaced at least $50,000 in identified annual savings, the engagement is free.",
  },
  {
    question: "What makes this different from other options?",
    answer:
      "Most AI advice comes from one of two places: generalists who hand you a prompt template, or firms that hand you a $500K slide deck. We do the diagnosis, build the systems, and hand them off.",
  },
  {
    question: "What do I need to do next?",
    answer: "Book a call below 👇",
  },
];

const FAQ = () => {
  return (
    <section id="faq" className="section-padding bg-background">
      <div className="section-container">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-12 lg:mb-16">
            <span className="text-sm font-semibold uppercase tracking-wider text-gold mb-4 block">
              FAQ
            </span>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-serif leading-tight">
              Common Questions
            </h2>
          </div>

          <Accordion type="single" collapsible className="space-y-4">
            {FAQS.map((faq, index) => (
              <AccordionItem
                key={index}
                value={`item-${index}`}
                className="bg-secondary rounded-xl px-6 border border-border data-[state=open]:border-gold/30 data-[state=open]:shadow-md transition-all">
                <AccordionTrigger className="text-left text-navy font-serif text-lg hover:no-underline py-5">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-body-gray pb-5 leading-relaxed">
                  <p>{faq.answer}</p>
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>

          {/* Always-visible CTA below the FAQs */}
          <div className="text-center mt-12">
            <Button variant="gold" size="xl" className="gap-3 text-white font-bold bg-gradient-to-br from-gold to-orange-400 hover:from-gold-dark hover:to-orange-500" asChild>
              <Link to="/get-started">
                Get Started
                <ArrowRight className="w-5 h-5" />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
